import { render } from "./HorseHistoryView.vue?vue&type=template&id=f90185e8"
import script from "./HorseHistoryView.vue?vue&type=script&lang=js"
export * from "./HorseHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__